const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/DashboardPage/Cards/MedicationCard/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        cardTitle: 'Medikamente',
        medicationText: '{count, plural, =0 {Keine Medikamente} =1 {1 Medikament} other {# Medikamente}}',
    },
    __RELATIVE_SOURCE_FILE__
);
